import kamala from '../../kamala'
import Carousel from './Carousel'
import CarouselItem from './CarouselItem'

const KCarouselFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(CarouselItem.name, CarouselItem)
    Vue.component(Carousel.name, Carousel)
  },
  KCarousel: Carousel,
  KCarouselItem: CarouselItem,
}

export {
  Carousel,
  CarouselItem,
}

export default KCarouselFamily
